module.exports = __webpack_public_path__ + "static/media/ci.6604e2cc.svg";